import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

export interface PublicProfile {
  tenant: { name: string; slug: string; phone: string | null; whatsapp: string | null; email: string | null; logoUrl: string | null };
  landing: { heroTitle: string; heroSubtitle: string; benefits: Array<{ title: string; text: string }>; faqs: Array<{ q: string; a: string }> };
  coverageText: string | null;
  cancellationPolicy: string | null;
  services: Array<{ id: string; code: string; name: string; description: string | null; icon: string | null }>;
  drivers: Array<{
    id: string;
    firstName: string;
    lastName: string;
    bio: string | null;
    experienceYears: number | null;
    photoUrl: string | null;
    rating: { average: string; count: number };
    vehicles: Array<{
      id: string;
      make: string;
      model: string;
      year: number;
      color: string;
      type: string;
      passengerCapacity: number;
      airConditioning: boolean;
      photos: Array<{ kind: string; url: string }>;
    }>;
  }>;
  reviews: Array<{ rating: number; comment: string | null; author: string; createdAt: string }>;
  /** Enlace personal de un conductor (/c/<código>). */
  invitedBy: { code: string; firstName: string } | null;
}

/** Con `driverCode` (enlace personal) la página muestra solo a ese conductor. */
export function usePublicProfile(driverCode?: string) {
  return useQuery({
    queryKey: ['public-profile', driverCode ?? null],
    queryFn: () => api<PublicProfile>('/public/profile', { query: { driver: driverCode } }),
    staleTime: 5 * 60_000,
  });
}

export function whatsappLink(number: string | null | undefined, text = 'Hola, quisiera solicitar un viaje con TuConductorRD.') {
  const digits = (number ?? '').replace(/\D/g, '');
  return digits ? `https://wa.me/${digits}?text=${encodeURIComponent(text)}` : null;
}
